<template>
    <main class="c-app-content is-sidebar-tiny">
        <g-loading v-if="firstLoading" />
        <g-table v-else :filter="filterFormModel" :itemCount="itemCount" :items="items" :fields="fields" :isSearch='false' @load="load" @reset="reset"
                 title="Điểm đến xanh" titleIcon="fa fa-map-marker-alt">
            <template slot="filter">
            </template>
            <template #cell(title)="{item}">
                <span :class="(item.blocked ? 'c-signal' : 'c-signal is-success')"><span class="h-word-break">{{item.title}}</span></span>
                <span class="badge bg-gray ml-1" >{{ $params.placeGreen.typeOptions.find(o => o.value === item.type).text}}</span>
            </template>
            <template slot="action">
                <g-button :loading="saveLoading" v-if="permissions('place-green_create')"  size="sm" variant="success" icon="fa fa-plus" content="Thêm mới"  @click="create" />
            </template>
            <template #cell(action)="{item}">
                <g-button v-if="permissions('place-green_update')"  :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click="update(item.id)"  />
                <g-button v-if="permissions('place-green_del')"  :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1"   icon="trash-fill" @click='del(item.id)' />
            </template>
        </g-table>
        <b-modal v-model="showForm" size="xl" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <div class="row">
                <div class="col-md-6">
                    <form-select label="Loại thẻ" :model="formModel" attribute="type" :errors="formErrors" :options="$params.placeGreen.typeOptions"  />
                    <form-input label="Tên thẻ" :required='true' :model="formModel" attribute="title" :errors="formErrors" desc="Tên riêng sẽ hiển thị trên website của bạn" />
                    <!-- <form-input label="Đường dẫn" :required='true' :model="formModel" attribute="slug" :errors="formErrors" desc="Chuỗi cho đường dẫn tĩnh là phiên bản của tên hợp chuẩn với Đường dẫn (URL). Chuỗi này bao gồm chữ cái thường, số và dấu gạch ngang (-)." /> -->
                    <form-checkbox chk-label="Tạm ẩn trên website" :model="formModel" :errors="formErrors"  attribute="blocked" />
                </div>
                <div class="col-md-6">
                    <AddGoogleMap :model="formModel" :errors="formErrors" :required='true' attribute="addressAll" label="Địa chỉ"/>
                </div>
            </div>
            <template v-slot:modal-footer="{ ok, cancel}">
                <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="ok">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    <em v-else class="fa fa-save" ></em>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </main>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import role from '@/mixins/Role';
    import AddGoogleMap from "@/components/AddGoogleMap";
 
    // import FormMedia from '@/components/media/FormMedia';

    export default {
        components: {AddGoogleMap},
        mixins: [list, crud, role],
        data: function () {
            return {
                reloadBus: "reloadPlaceGreen",
                service: '/place-green',
                fields: [
                    {key: 'title', label: "Tên thẻ", class: 'text-left'},
                    {key: 'address', label: "Địa chỉ", class: 'text-left'},
                    {key: 'action', label: "Hành động", class: 'text-right'},
                ],
                defaultFilterFormModel: {
                    keyword: '',
                },
                defaultFormModel: {
                    title: null,
                    slug: null,
                    addressAll: {},
                    type: 1,
                    blocked: 0
                },
            }
        },
        watch: {
            "formModel.name": {
                handler(val) {
                    if (val && (!this.formModel.id || !this.formModel.slug)) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            },
            "formModel.slug": {
                handler(val) {
                    if (val) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            }
        },
        methods: {
            search(val) {
                this.filterFormModel.type = val;
                this.load();
            },
            reset() {
                this.filterFormModel.keyword = '';
                this.$router.go(this.$router.currentRoute)
            },
        },
        mounted() {
        }
    }
</script>